const URL =
  process.env.BASE_URL ||
  (!process.env.NODE_ENV || process.env.NODE_ENV == "development"
    ? "http://localhost:5000/api/"
    : "/api/");

const ApiConstants = {
  TOKEN: localStorage.getItem("kgen-token"),
  BASE_URL: URL,
  IMAGE_URL: "/api/images/",
  FILE_URL: "/api/files/",
  TABLE_HEIGHT: "auto",
};

export default ApiConstants;
